import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "@/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login", { replace: true });
      return;
    }
    exchangeSession(match[1])
      .then((user) => {
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true, state: { user } });
      })
      .catch(() => navigate("/admin/login", { replace: true }));
  }, [location.hash, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-sm text-muted-foreground" data-testid="auth-callback-screen">
      Signing you in…
    </div>
  );
}
